import { userData } from "../../../constant/data";

const WhoCanUseSection = () => {
  return (
    <section
      id="who-can-use"
      className="bg-[#001D21] rounded-tr-[24px] rounded-tl-[24px] rounded-br-[4px] rounded-bl-[4px] mt-20 px-10 xl:px-20 py-[64px]"
    >
      <div className="space-y-3">
        <h3 className="text-[#D4F3D5] text-2xl font-worksans">
          Who Can Use Fez Lockers
        </h3>
        <p className="font-onestMedium text-[#EBEBEB] text-lg">
          Fez SafeLockers are perfect for individuals and businesses
        </p>
        <div className="grid md:grid-cols-4 sm:grid-cols-2 grid-cols-1  gap-7 pt-3">
          {userData.map((data) => (
            <div className="relative w-full" key={data.id}>
              <img
                src={data.img}
                width={"100%"}
                className="rounded-[16px] "
                alt={`individual-icon ${data.id}`}
              />
              <div className="absolute bottom-2 px-3">
                <p className="font-onestMedium text-[#D4F3D5] text-lg">
                  {" "}
                  {data.field}
                </p>
                <p className="text-[#D4F3D5] text-base font-onest">
                  {data.content}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhoCanUseSection;
